// extracted by mini-css-extract-plugin
module.exports = {"nav":"navInstitutional_nav__1gEgf","nav__list_option":"navInstitutional_nav__list_option__3sITe","nav__list_item":"navInstitutional_nav__list_item__2R3SQ"};